import styled from 'styled-components'

export const ItemContainerStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`
